<template>
 <v-container class="grey lighten-5" style="min-height:100%;">

       <v-snackbar
      v-model="toast"
      timeout="2000"
      color="green"
    >
   بروزرسانی با موفقیت انجام شد

    </v-snackbar>

    <v-row>



        <v-col cols="12" sm="12" class="py-0 px-0" >
    <v-card style="padding-bottom:100px" flat>
          <v-card-text >
     
             
<v-alert v-if="user.profile_accepted == 1" dense
  color="orange" text
>
در انتظار تایید اطلاعات کاربری 
</v-alert>
  <v-alert v-if="user.profile_accepted != 0 && user.profile_accepted != 1 && user.profile_accepted != 2" dense
  color="orange" text
>
{{user.profile_accepted}}
</v-alert>
  <v-alert v-if="user.profile_accepted == 2" dense
  color="green" text
>
اطلاعات کاربری شما تایید شد
</v-alert>


 <v-text-field
 v-model="user.first_name"
            label="نام"
            outlined
          ></v-text-field>

           <v-text-field
            v-model="user.last_name"
            label="نام خانوادگی"
            outlined
          ></v-text-field>


   <v-text-field
         v-model="user.national_code"
            label="کد ملی"
            class="ltr"
            outlined
          ></v-text-field>

   <v-text-field
      v-model="user.email"
      class="ltr"
            label=" ایمیل"
            outlined
          ></v-text-field>
             <v-text-field
                v-model="user.mobile"
                class="ltr"
                readonly
            label=" شماره همراه"
            outlined
          ></v-text-field>
             <v-text-field
                v-model="user.phone"
                class="ltr"
            label=" شماره ثابت"
            outlined
          ></v-text-field>
       <v-select
                  v-model="user.province_id"
                  :loading="provinces.length == 0"
          :items="provinces"
          item-text="name"
          item-value="id"
          label="استان یا منطقه"
          outlined
        ></v-select>

          

   <v-text-field
      v-model="user.address"

            label="آدرس محل سکونت "
            outlined
          ></v-text-field>

   <v-text-field
      v-model="user.postal_code"
      class="ltr"
            label=" کد پستی محل سکونت"
            outlined
          ></v-text-field>

        

          </v-card-text>
    </v-card>
        </v-col>

    </v-row>
        <v-footer
 fixed
   padless

      flat
      class="bottom-navigation"
      color="white"
      dark
      style="bottom:60px"
    >
    <v-btn
  block
  large
  :loading="loading"
  @click="save"
  color="secondary"
  tile
>ذخیره اطلاعات</v-btn>
    </v-footer>

 </v-container>
</template>
<script>
  export default {
    data: () => ({
      password: 'Password',
      show: false,
      message: '',
      toast : false,
      marker: true,
   loading : false,
    }),

    computed: {
      provinces () {
        if(this.$store.state.cities.length > 0){
  return this.$store.state.cities.filter(
          city => city.parent == 0);
        }else{
          return []
        }
  
      },
           user (){
             
         return this.$store.state.user_changes
      

 }
    },
   

 mounted(){



 },
    methods: {
save(){
  const _this = this
  this.loading = false
  console.log(this.user)
     var senddata = {  data: {  data: ['update', 'agents',
    {
first_name : this.user.first_name,
last_name : this.user.last_name,
national_code : this.user.national_code,
email : this.user.email,
phone : this.user.phone,
province_id : this.user.province_id,
address : this.user.address,
postal_code : this.user.postal_code,
profile_accepted : 1,
    },{id: this.user.id}
    ]}, actions: ['insert'] };
 
     this.api_get(senddata).then((data) => {
       console.log(data)
       _this.$store.state.user_changes.profile_accepted = 1
  _this.loading = false
  _this.toast = true
     })
}

    },
  }
</script>
